import { Link } from "react-router-dom";
import { BadgeCheck, Ban } from "lucide-react";
import { PROPERTY_TYPES } from "../../lib/categories";

export function DirectOwnerBadge({ big = false }) {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full bg-green-600 text-white font-bold ${big ? "px-4 py-2 text-base md:text-lg" : "px-2 py-0.5 text-[11px]"}`} data-testid={big ? "direct-owner-badge-big" : "direct-owner-badge"}>
      <BadgeCheck className={big ? "w-5 h-5" : "w-3.5 h-3.5"} /> डायरेक्ट मालक - नो कमिशन
    </span>
  );
}

export default function PropertyHighlight({ counts }) {
  return (
    <section className="max-w-7xl mx-auto px-4 mt-10" data-testid="property-highlight">
      <div className="rounded-3xl overflow-hidden border-2 border-green-600 bg-white">
        <div className="bg-green-700 text-white px-5 py-4 md:py-5 text-center">
          <p className="font-display font-extrabold text-xl md:text-3xl flex items-center justify-center gap-2 flex-wrap" data-testid="property-banner-text">
            <Ban className="w-6 h-6" /> नो ब्रोकर - नो दलाल - प्रॉपर्टी डायरेक्ट मालकाकडून
          </p>
          <p className="text-sm md:text-base text-green-100 mt-0.5">शेतजमीन, प्लॉट, घर, दुकान - थेट मालकाशी बोला, एक रुपया कमिशन नाही!</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 p-4 md:p-5">
          {Object.entries(PROPERTY_TYPES).map(([k, { mr, en, icon: Icon, color, bg }]) => (
            <Link key={k} to={`/buy?category=Property&ptype=${k}`} className="group rounded-2xl border border-slate-200 p-4 flex items-center gap-3 hover:border-green-600 hover:shadow-md transition-[box-shadow,border-color]" data-testid={`property-type-${k}`}>
              <span className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" style={{ background: bg, color }}><Icon className="w-6 h-6" /></span>
              <span className="leading-tight">
                <span className="block font-display font-bold text-lg text-[var(--navy)]">{mr}</span>
                <span className="block text-xs text-slate-500">{en}{counts?.[k] ? ` · ${counts[k]}` : ""}</span>
              </span>
            </Link>
          ))}
        </div>
        <div className="px-5 pb-5 flex flex-wrap gap-3 justify-center">
          <Link to="/sell?category=Property" className="h-12 px-6 rounded-xl bg-green-600 hover:bg-green-700 text-white font-display font-bold text-lg flex items-center transition-colors" data-testid="property-sell-button">प्रॉपर्टी विका - मोफत जाहिरात</Link>
          <Link to="/buy?category=Property" className="h-12 px-6 rounded-xl border-2 border-green-600 text-green-700 font-display font-bold text-lg flex items-center hover:bg-green-50 transition-colors" data-testid="property-browse-button">सर्व प्रॉपर्टी पहा</Link>
        </div>
      </div>
    </section>
  );
}
